<template>
<v-card 
  flat 
  tile 
  class="elevation-0" 
  style="height:100%; background-color:transparent">
  
  <v-card-text 
    class="py-0"
    style="background-color:transparent;">
    
    <v-card class="elevation-2">

      <v-card-text>

        <v-container>

          <v-layout row wrap>

            <v-flex xs5>

              <v-form ref="formFinishingOne" lazy-validation>          

                <v-select
                  dense
                  :items="items"
                  v-model="editedItem.decision"
                  :rules="decisionRules"
                  label="Decisão Técnica"
                  outlined>
                </v-select>

                <v-select
                  dense
                  :items="hospitals"
                  return-object
                  item-text="name"
                  v-model="editedItem.destiny"
                  label="Destino Paciente"
                  outlined>
                </v-select>
              </v-form>
            </v-flex>

            <v-spacer></v-spacer>

            <v-flex xs6>

              <v-form 
                ref="formFinishingTwo" 
                lazy-validation>
                <v-textarea
                  outlined
                  v-model="editedItem.obs"
                  :rules="obsRules"
                  label="Observação">
                </v-textarea>
              </v-form>

              <span
                v-if="errorNotFinishing"
                class="red--text">
                É necessário encerrar a ocorrência para todas as vítimas!
              </span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-card-text>
</v-card>
</template>

<script>
export default {
  name: "StepFinishing",
  data: () => ({
    patient: undefined,
    items: ["Emcaminhamento", "Internação", "Operação", "Emergencia"],
    item: ["28 de Agosto", "João Lucio"],
    ite: ["Trauma", "Acidente", "Overdose", "Desconhecido"],
    editedItem: {
      dateHour: "",
      decision: "",
      destiny: "",
      intercurrence: "",
      obs: "",
      situation: "",
    },
    defaultItem: {
      dateHour: "",
      decision: "",
      destiny: "",
      intercurrence: "",
      obs: "",
      situation: "",
    },
    headers: [
      { text: "Data/Hora", value: "dateHour", sortable: false },
      { text: "Decisão Técnica", value: "decision", sortable: false },
      { text: "Destino", value: "destiny", sortable: false },
      { text: "Intercorrência", value: "intercurrence", sortable: false },
      { text: "Observação", value: "obs", sortable: false },
      { text: "Situação", value: "situation", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
    errorNotFinishing: false,
    decisionRules: [(v) => !!v || "É necessário selecionar a decisão!"],
    destinyRules: [(v) => !!v || "É necessário selecionar o destino!"],
    intercurrenceRules: [
      (v) => !!v || "É necessário selecionar a intercorrência",
    ],
    obsRules: [(v) => !!v || "É necessário preencher a observação"],
    situationRules: [(v) => !!v || "É necessário selecionar a situação"],
    victimsFinished: [],
  }),
  mounted (){
    this.$store.dispatch("loadHospitals");
  },
  computed: {
    hospitals (){
      return this.$store.getters.hospitals;
    },
  },
  methods: {
    setFinishingVictim (){
      let validate =
        this.$refs.formFinishingOne.validate() &&
        this.$refs.formFinishingTwo.validate();
      if (validate) {
        this.victimsFinished.push({
          ...this.patient,
          finishing: { ...this.editedItem },
        });
        this.$refs.formFinishingOne.reset();
        this.$refs.formFinishingOne.resetValidation();
        this.$refs.formFinishingTwo.reset();
        this.$refs.formFinishingTwo.resetValidation();
      }
    },
    clearStep (){
        this.victimsFinished = []
        this.$refs.formFinishingOne.reset();
        this.$refs.formFinishingOne.resetValidation();
        this.$refs.formFinishingTwo.reset();
        this.$refs.formFinishingTwo.resetValidation();
    },
  },
};
</script>

<style>
</style>